import { Alert } from "@mui/material";
import React, { createContext, useEffect, useState } from "react";


interface ConfigContextProps {
    loginUrl: string;
    apiUrl: string;
    allowedRedirectUris: string[];
    redirectUri?: string
}
  
export const ConfigContext = createContext<ConfigContextProps | undefined>(undefined)

export const ConfigProvider: React.FC = (props) => {

  const [config, setConfig] = useState<ConfigContextProps | undefined>(undefined)
  const [error, setError] = useState<Error | undefined>(undefined)

  useEffect(() => {
    fetch("/config/config.json")
      .then(response => response.json())
      .then(json => setConfig(json as ConfigContextProps))
      .catch(() => {
        setError(Error(""))
      })
  }, [])

  return config !== undefined ? (
    <ConfigContext.Provider value={config}>
      {props.children}
    </ConfigContext.Provider>
  ) :
  <Alert severity='error'>Kunne ikke hente config</Alert>
}